<div *ngIf="isLoading" class="loading">
  <div class="uil-ring-css" style="transform: scale(0.79)">
    <div></div>
  </div>
</div>

<div class="p-16" fxLayoutGap="10px" fxLayout="column">
  <mat-card fxFlexLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
    <mat-form-field appearance="outline">
      <mat-label>Du</mat-label>
      <input
        matInput
        [matDatepicker]="date_Debut"
        placeholder="Du"
        [(ngModel)]="dateDeb"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="date_Debut"
      ></mat-datepicker-toggle>
      <mat-datepicker #date_Debut></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Au</mat-label>
      <input
        matInput
        [matDatepicker]="date_Fin"
        placeholder="Au"
        [(ngModel)]="dateFin"
      />
      <mat-datepicker-toggle matSuffix [for]="date_Fin"></mat-datepicker-toggle>
      <mat-datepicker #date_Fin></mat-datepicker>
    </mat-form-field>

    <button
      [disabled]="!dateDeb || !dateFin"
      fxFlex="10"
      mat-raised-button
      color="primary"
      (click)="refreshData()"
    >
      Rechercher
    </button>
    <!-- <button [disabled]="!dataLoaded" fxFlex="10" mat-raised-button color="success" (click)="exporter.exportTable('Excel',{ 'fileName' : 'Uniges_SOF_Details___' + dateDeb + '___' + dateFin})" >Exporter Excel</button>
        <button [disabled]="!dataLoaded " mat-raised-button color="success" (click)="exporter.exportTable('csv',{ 'fileName' : 'Uniges_SOF_Details___' + dateDeb + '___' + dateFin })" >Exporter CSV</button> -->
  </mat-card>

  <div class="shadow rounded border-b border-gray-200 tableWrap">
    <table class="w-full bg-white">
      <thead class="bg-gray-800 text-white">
        <tr>
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Date
          </th>

          <th
            class="w-1/3 text-left py-3 px-16 uppercase font-semibold text-sm"
          >
            OF
          </th>
          <th
            class="w-1/3 text-left py-3 px-16 uppercase font-semibold text-sm"
          >
            Prenom
          </th>
          <th
            class="w-1/3 text-left py-3 px-16 uppercase font-semibold text-sm"
          >
            Nom
          </th>

          <th
            class="w-1/3 text-left py-3 px-16 uppercase font-semibold text-sm"
          >
            Machine
          </th>

          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Réalisé
          </th>
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Objectif
          </th>
          <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
            Gain
          </th>
        </tr>
      </thead>
      <tbody class="text-gray-700">
        <tr
          (click)="selectedLine = i"
          class="hover:bg-gray-800 hover:text-white hover:transition"
          *ngFor="let line of SummarySource; index as i"
          [class]="
            i == selectedLine
              ? 'selectedLine'
              : i % 2 == 0
              ? 'bg-gray-100 '
              : ''
          "
        >
          <td class="w-1/3 text-left py-3 px-16">
            {{ line.debut | date: "DD/MM/YYYY" }}
          </td>

          <td class="w-1/3 text-left py-3 px-16">
            {{ line.OF_Num }}
          </td>
          <td class="w-1/3 text-left py-3 px-16">
            {{ line.prenom }}
          </td>
          <td class="w-1/3 text-left py-3 px-16">
            {{ line.nom }}
          </td>
          <td class="w-1/3 text-left py-3 px-16">
            {{ line.Machine_Code }}
          </td>

          <td class="text-left py-3 px-16">
            {{ line["Realisé"] }}
          </td>
          <td class="text-left py-3 px-16">
            {{ line.objectif }}
          </td>
          <td class="text-left py-3 px-16">
            {{ line.gain }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- <app-table #tableSummary [source]="SummarySource"></app-table> -->
</div>
